/** WGS84 楕円体の地球半径（赤道半径に近似, m） */
export const EARTH_RADIUS = 6378137;

/** 緯度1度あたりのメートル数（約111.32km） */
export const METERS_PER_DEGREE_LATITUDE = 111320;
